<template>
	<b-modal
		id="viewconfigModal"
		centered
		hide-footer
		hide-header
		v-model="showModal"
		no-close-on-backdrop
	>
		<header
			class="d-flex align-items-center justify-content-between viewcon-border-bottom head"
		>
			<div
				class="font-lato fw-500 fs-18 color-black d-flex align-items-center gap-2 pointer"
			>
				<img
					@click="$emit('close-modal')"
					src="../../assets/common-icons/modal-back-arrow.svg"
					alt=""
				/><span>Add/Select Configuration</span>
			</div>
			<div @click="$emit('close-modal')">
				<img
					class="rotate-on-hover pointer"
					src="../../assets/common-icons/blue-cross.svg"
					alt=""
				/>
			</div>
		</header>
		<!-- 655.97 -->
		<div class="viewcon-tabs-height ">
			<div class="viewcon-modal-scroll">
				<div class="d-flex justify-content-between mb-3">
					<div class="position-relative w-50">
						<img
							class="search-image-position"
							src="../../assets/common-icons/magni.svg"
							alt=""
						/>
						<b-form-input
							class="config-search-input"
							placeholder="Search Configuration"
							type="search"
							@update="performSearch"
							v-model="searchConfig"
							debounce="500"
							clearable
						>
						</b-form-input>
					</div>
					<div class="d-flex align-items-center gap-4">
						<div ref="rec" class="position-relative">
							<b-button class="new-addBtn mt-1" @click="toggleFilter()"
								><img
									class="mr-2"
									src="../../assets/common-icons/filter.svg"
									alt=""
								/><span v-if="filtercount > 0" class="filter-red-dot"></span>
								Filter</b-button
							>
							<div
								class="new-filtercard"
								v-if="showFilter"
								ref="recdropdown"
								v-closable="{
									exclude: ['rec', 'recdropdown'],
									handler: 'hideDropdown',
								}"
							>
								<div>
									<SingleSelect
										text="Configure Type:"
										v-model="filterSelected"
										:optionsArray="filteroptions"
									/>
									<div
										class="filter-footer d-flex align-items-center justify-content-between mt-3"
									>
										<div class="padding-2-15 filter-button">
											<b-button @click="hideDropdown()">Cancel</b-button>
										</div>
										<div class="padding-2-15 filter-button">
											<b-button @click="resetFilter()" class="mr-3"
												>Reset</b-button
											>
											<b-button
												@click="applyFilter()"
												:disabled="filterSelected == null"
												>Apply</b-button
											>
										</div>
									</div>
								</div>
							</div>
						</div>
						<b-button class="new-addBtn mt-1" @click="$emit('add-config')"
							><img
								class="mr-2"
								src="../../assets/common-icons/whitePlus.svg"
								alt=""
							/>
							Configuration</b-button
						>
					</div>
				</div>
				<div class="view-con-hor-scroll">
					<div
						v-if="selectedConfig && Object.keys(selectedConfig).length"
						class="sel-config-card  min-width-1200 my-3 "
					>
						<article class="tag">Selected Configuration</article>
						<article class="color-bar"></article>
						<div class="one pl-2 d-flex align-items-center">
							<b-form-radio
								v-model="selectedConfigID"
								:value="selectedConfigID"
								disabled
							></b-form-radio>
							<div class="pl-2 w-90">
								<div class="font-mont fw-400 fs-13 color-696969">
									Configuration Name
								</div>
								<div
									class="font-lato fw-400 fs-15 color-72738e mt-1 w-100 text-truncate"
								>
									{{ selectedConfig.configName }}
								</div>
							</div>
						</div>
						<div class="three">
							<div class="font-mont fw-400 fs-13 color-696969">
								Starting Time
							</div>
							<div class="font-lato fw-400 fs-15 color-72738e mt-1">
								<span v-if="selectedConfig.config">
									{{ selectedConfig.config.openTestdt | datefilter }}
								</span>
								<span v-else>--</span>
							</div>
						</div>
						<div class="four">
							<div class="font-mont fw-400 fs-13 color-696969">Ending Time</div>
							<div class="font-lato fw-400 fs-15 color-72738e mt-1">
								<span v-if="selectedConfig.config">
									{{ selectedConfig.config.closeTestdt | datefilter }}
								</span>
								<span v-else>--</span>
							</div>
						</div>
						<div class="five">
							<div class="font-mont fw-400 fs-13 color-696969">Test Type</div>
							<div class="font-lato fw-400 fs-15 color-72738e mt-1">
								<span v-if="selectedConfig.config">
									{{ selectedConfig.config.test }}
								</span>
								<span v-else>--</span>
							</div>
						</div>
						<div class="six">
							<div class="font-mont fw-400 fs-13 color-696969">Status</div>
							<div class="font-lato fw-400 fs-15 mt-1">
								<span v-if="selectedConfig.open == 'False'" class="color-red"
									>Expired</span
								>
								<span v-else class="color-green">Active</span>
							</div>
						</div>
						<div class="d-flex align-items-center gap-3 seven">
							<img
								class="pointer"
								@click="$emit('view-config', selectedConfig.configID)"
								src="../../assets/icons/proctoring/eye.svg"
								alt=""
							/>
							<img
								@click.stop="$emit('edit-config', selectedConfig.configID)"
								class="pointer"
								src="../../assets/icons/Qpbuilder/edit.svg"
								alt=""
							/>
						</div>
					</div>
					<div class="viewcon-header  min-width-1200 mb-2">
						<div class="one-alpha pl-40">
							Name

							<template v-if="sortColumn == 'configName'">
								<img
									@click="sort('configName'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/common-icons/upsort.svg"
									alt=""
									class="pointer ml-1"
								/>
								<img
									v-else
									@click="sort('configName'), (sorting = !sorting)"
									src="../../assets/common-icons/downsort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</template>
							<img
								v-else
								@click="sort('configName'), (sorting = !sorting)"
								src="../../assets/common-icons/nosort.svg"
								alt=""
								class="pointer ml-1"
							/>
						</div>
						<div class="three">
							Start Date
							<template v-if="sortColumn == 'openTestdt'">
								<img
									@click="sort('openTestdt'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/common-icons/upsort.svg"
									alt=""
									class="pointer ml-1"
								/>
								<img
									v-else
									@click="sort('openTestdt'), (sorting = !sorting)"
									src="../../assets/common-icons/downsort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</template>
							<img
								v-else
								@click="sort('openTestdt'), (sorting = !sorting)"
								src="../../assets/common-icons/nosort.svg"
								alt=""
								class="pointer ml-1"
							/>
						</div>
						<div class="four">
							End Date

							<template v-if="sortColumn == 'closeTestdt'">
								<img
									@click="sort('closeTestdt'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/common-icons/upsort.svg"
									alt=""
									class="pointer ml-1"
								/>
								<img
									v-else
									@click="sort('closeTestdt'), (sorting = !sorting)"
									src="../../assets/common-icons/downsort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</template>
							<img
								v-else
								@click="sort('closeTestdt'), (sorting = !sorting)"
								src="../../assets/common-icons/nosort.svg"
								alt=""
								class="pointer ml-1"
							/>
						</div>
						<div class="five">
							Test Type
							<template v-if="sortColumn == 'testType'">
								<img
									@click="sort('testType'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/common-icons/upsort.svg"
									alt=""
									class="pointer ml-1"
								/>
								<img
									v-else
									@click="sort('testType'), (sorting = !sorting)"
									src="../../assets/common-icons/downsort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</template>
							<img
								v-else
								@click="sort('testType'), (sorting = !sorting)"
								src="../../assets/common-icons/nosort.svg"
								alt=""
								class="pointer ml-1"
							/>
						</div>
						<div class="six">
							Status
							<template v-if="sortColumn == 'open'">
								<img
									@click="sort('open'), (sorting = !sorting)"
									v-if="sorting == true"
									src="../../assets/common-icons/upsort.svg"
									alt=""
									class="pointer ml-1"
								/>
								<img
									v-else
									@click="sort('open'), (sorting = !sorting)"
									src="../../assets/common-icons/downsort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</template>
							<img
								v-else
								@click="sort('open'), (sorting = !sorting)"
								src="../../assets/common-icons/nosort.svg"
								alt=""
								class="pointer ml-1"
							/>
						</div>
						<div class="seven-alpha">Action</div>
					</div>
					<div
						:class="
							selectedConfig && Object.keys(selectedConfig).length
								? 'viewcon-vertical-scroll-2'
								: 'viewcon-vertical-scroll'
						"
					>
						<template v-if="LoaderStatus">
							<div v-for="i in 7" :key="i">
								<b-skeleton width="100%" height="50px"></b-skeleton>
							</div>
						</template>
						<template v-else-if="this.configurations.length > 0">
							<div
								v-for="data in configurations"
								:key="data.configID"
								class="sel-config-card font-lato fw-400 fs-15 color-72738e  min-width-1200 mb-2"
								@click="handleCardClick(data)"
							>
								<div class="active-bar red"></div>
								<div class="one-alpha pl-2 d-flex align-items-center">
									<b-form-radio
										:value="data.configID"
										v-model="selectedConfigID"
										@change="handleCardClick(data)"
										:disabled="data.open === 'False'"
									></b-form-radio>
									<div class="pl-2 w-90 double-line-truncate">
										{{ data.configName }}
									</div>
								</div>
								<div class="three">
									<span v-if="data.config.openTestdt != null">
										{{ data.config.openTestdt | datefilter }}
									</span>
									<span v-else> -- </span>
								</div>
								<div class="four">
									<span v-if="data.config.closeTestdt != null">
										{{ data.config.closeTestdt | datefilter }}
									</span>
									<span v-else> -- </span>
								</div>
								<div class="five">
									<span v-if="data.config.test != null">
										{{ data.config.test }}
									</span>
									<span v-else> -- </span>
								</div>
								<div class="six color-green">
									<span v-if="data.open == 'False'" class="color-red"
										>Expired</span
									>
									<span v-else class="color-green">Active</span>
								</div>
								<div class="seven-alpha d-flex gap-3">
									<img
										class="pointer"
										@click.stop="$emit('view-config', data.configID)"
										src="../../assets/icons/proctoring/eye.svg"
										alt=""
									/>
									<img
										class="pointer"
										@click.stop="$emit('edit-config', data.configID)"
										src="../../assets/icons/Qpbuilder/edit.svg"
										alt=""
									/>
								</div>
							</div>
						</template>
						<template v-else-if="searchConfig != ''">
							<div class="relativeclass mr-2" style="height: 97%" id="top1">
								<div
									class="d-flex flex-column align-items-center justify-content-center h-100"
								>
									<div style="height: 140px;">
										<img
											class="h-100"
											src="../../assets/searchnotfound.svg"
											alt=""
										/>
									</div>

									<div class="text-center">
										<span class="searchnotfound"
											>No matching results for
											<span class="searchtext text-break">
												"{{ searchConfig }}"
											</span>
											.</span
										>
									</div>
								</div>
							</div>
						</template>
						<template
							v-else-if="
								configurations.length == 0 &&
									!LoaderStatus &&
									searchConfig != ' '
							"
						>
							<div style="height: 140px;">
								<img
									class="h-100"
									src="../../assets/nodata.svg"
									alt="No data found"
								/>
							</div>
						</template>
					</div>
				</div>
			</div>
			<div
				class="acs-paginaTion-new d-flex justify-content-between align-items-center min-width-1200"
			>
				<div class="d-flex">
					<span class="acs-gotopage-text mr-2 p-1">Go to page</span>
					<div class="acs-pagination-num">
						<b-form-input
							class="no-number"
							type="text"
							v-model.trim="goToPage"
							@keyup.enter="
								goToPage === null || goToPage == '' || !iscontainsNumber
									? ''
									: goToPages(goToPage)
							"
						>
						</b-form-input>
					</div>

					<div class="acs-pagination-addbtn">
						<b-button
							:disabled="
								goToPage === null || goToPage == '' || !iscontainsNumber
							"
							@click="goToPages(goToPage)"
						>
							<img src="../../assets/common-icons/page-arrow.svg" alt="" />
						</b-button>
					</div>
				</div>
				<div class="d-flex justify-content-center pagination ml-135">
					<b-pagination
						v-model.number="currentPage"
						@input="goToPageNum()"
						:total-rows="total"
						:per-page="count"
						align="center"
						first-number
						last-number
					>
						<template #prev-text
							><span
								><img
									src="../../assets/common-icons/pageLeft.svg"
									alt=""
								/> </span
						></template>
						<template #next-text
							><span
								><img
									src="../../assets/common-icons/pageRight.svg"
									alt=""/></span
						></template>
					</b-pagination>
				</div>
				<div class="d-flex align-items-center">
					<PaginationCountSelect
						:pagecount="count"
						@update-value="getPageCount"
					/>
					<div
						class="acs-gotopage-text mr-2 ml-4 d-flex align-items-center justify-content-end"
					>
						Results : <span class="mr-1" v-if="pageStart > total">0</span
						><span class="mr-1" v-else>{{ pageStart }}</span>
						-
						{{ pageEnd }}
						<span class="pl-1"></span> of <span class="pr-1"></span>{{ total }}
					</div>
				</div>
			</div>
			<div class="d-flex justify-content-end py-2 px-4">
				<div class="d-flex align-items-center gap-4">
					<b-button @click="$emit('close-modal')" class="new-cancelBtn mt-1 "
						>Cancel</b-button
					>
					<b-button
						@click="postConfig(selectedConfig)"
						:disabled="
							!selectedConfig || Object.keys(selectedConfig).length === 0
						"
						class="new-addBtn mt-1"
						>Select</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import SingleSelect from "../../components/InputComponents/SingleSelect.vue";
import PaginationCountSelect from "../fixedcomponents/PaginationCountSelect.vue";
import { postTaggedConfig } from "@/utils/apiFunctions";
export default {
	data() {
		return {

			selectedConfigID: null,
			configurations: [],
			selectedConfig: {},
			expiredConfig: {},
			allConfigurations: [],

			pageStart: null,
			pageEnd: null,
			total: null,
			totalPages: null,
			count: 10,
			currentPage: 1,
			goToPage: null,

			sortOrder: false,
			sortColumn: "createdAt",

			showFilter: false,
			filterSelected: null,
			storefilter: null,
			filtercount: 0,
			sorting: false,

			searchConfig: "",

			filteroptions: [
				{ text: "All", value: "all" },
				{ text: "Active", value: "true" },
				{ text: "Inactive", value: "false" },
			],
			LoaderStatus: false,
		};
	},
	created() {
		this.LoaderStatus = true;
		this.getConfig();
		this.getAllConfig();
	},
	computed: {
		// To check if it does not contain an alphabet or zero
		iscontainsNumber() {
			return /^[1-9]\d*$/.test(this.goToPage);
		},
	},
	watch: {
		showModal(val) {
		console.log("the value hee is", val);
			if (val) {
				this.selectedConfig = {};
				this.selectedConfigID = null;
				this.updateSelection(this.preSelectedConfigId);
			}
		},
		async newConfigID(val) {
			await this.getConfig();
			if (val) {
				const match =
					this.configurations.find((c) => c.configID === val) ||
					this.allConfigurations.find((c) => c.configID === val);
				if (match) {
					this.selectedConfig = match;
					this.selectedConfigID = match.configID;
				}
			}
		},
		updateConfig(val) {
			console.log("he update config value is", val);
			if (val) {
				this.getConfig();
			}
		},
		resetTrigger() {
			this.searchConfig = ""; // clear input whenever reset is triggered
			this.filtercount = 0;
			this.storefilter = null;
			this.filterSelected = "all";
			this.getConfig();
		},
		selectedConfigID(val) {
			if (val) {
				const match =
					this.configurations.find((c) => c.configID === val) ||
					this.allConfigurations.find((c) => c.configID === val);
				if (match) {
					this.selectedConfig = match;
				}
			}
		},
	},
	components: {
		PaginationCountSelect,
		SingleSelect,
	},
	props: {
		showModal: Boolean,
		preSelectedConfigId: {
			type: String, // or Number depending on your configID type
			default: null,
		},
		newConfigID: String,
		updateConfig: Boolean,
		resetTrigger: Number,
	},

	methods: {
		updateSelection(val) {
			if (val && this.preSelectedConfigId) {
				// Find matching config if configs are already loaded
				const match = this.allConfigurations.find(
					(c) => c.configID === this.preSelectedConfigId
				);
				if (match) {
					this.selectedConfig.configID = match.configID;
					this.selectedConfig = match;
					this.selectedConfigID = match.configID;
				} else {
					// Configs not loaded yet → wait until API returns
					this.selectedConfig.configID = this.preSelectedConfigId;
					this.selectedConfigID = this.preSelectedConfigId;
				}
			}
		},
		async postConfig(data) {
			this.$emit("post-config", data);
		},
		async getConfig() {
			try {
				this.LoaderStatus = true;
				const openValue =
					this.filterSelected?.value || this.filterSelected || "";
				let payload = {
					page: this.currentPage - 1,
					count: this.count,
					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					filters: {
						testType: "private",
						open: openValue,
					},

					searchQuery: this.searchConfig,
					testID: "",
				};
				if (openValue === "all") {
					delete payload.filters.open;
				}
				const res = await postTaggedConfig(payload);

				if (res.status == 200) {
					this.configurations = res.data.data.data;
					if (res.data.data.selectedConfig) {
						this.selectedConfig = res.data.data.selectedConfig;
						this.selectedConfigID = this.selectedConfig.configID;
					}
				}
				this.pageEnd = res.data.data.pageEnd;
				this.pageStart = res.data.data.pageStart;
				this.total = res.data.data.total;
				this.totalPages = Math.ceil(
					parseInt(this.total) / parseInt(this.count)
				);
				this.LoaderStatus = false;
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async getAllConfig() {
			const openValue = this.filterSelected?.value || this.filterSelected || "";
			try {
				let payload = {
					page: this.currentPage - 1,

					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					filters: {
						testType: "private",
						open: openValue,
					},

					searchQuery: this.searchConfig,
					testID: "",
				};
				if (openValue === "all") {
					delete payload.filters.open;
				}
				const res = await postTaggedConfig(payload);

				if (res.status == 200) {
					this.allConfigurations = res.data.data.data;
				}
				this.updateSelection(this.preSelectedConfigId);
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		selectConfig(data) {
			this.selectedConfig = data;
			this.selectedConfigID = data.configID;
		},
		handleCardClick(data) {
			if (data.open === "False") {
				// expired → emit to parent
				this.$emit("expired-warning", data);
			} else {
				// active → select normally
				this.selectConfig(data);
			}
		},
		getPageCount(val) {
			this.count = val;
			this.currentPage = 1;
			this.getConfig();
		},
		performSearch(newQuery) {
			this.searchConfig = newQuery;
			this.currentPage = 1;
			this.getConfig();
		},
		toggleFilter() {
			this.showFilter = !this.showFilter;
			if (this.filterSelected != "all") {
				this.filterSelected = this.storefilter;
			}
		},
		hideDropdown() {
			this.showFilter = false;
		},
		resetFilter() {
			if (this.filtercount > 0) {
				this.filtercount = 0;
				this.storefilter = null;
				this.filterSelected = "all";
				this.configurations = [];
				this.getConfig();
			} else {
				this.filtercount = 0;
				this.storefilter = null;
				this.filterSelected = "all";
			}
			this.showFilter = false;
		},
		applyFilter() {
			if (this.filterSelected != "all") {
				this.storefilter = this.filterSelected;
				this.currentPage = 1;
				this.configurations = [];
				this.getConfig();
			}
			this.filtercount = 1;
			this.showFilter = false;
		},
		sort(data) {
			this.sortColumn = data;
			this.sortOrder = !this.sortOrder;
			this.getConfig();
		},
		goToPages(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getConfig();
		},
		goToPageNum() {
			this.getConfig();
		},
	},
};
</script>

<style lang="scss">
#viewconfigModal {
	.modal-dialog {
		max-width: 1213px;
	}

	.modal-body {
		padding: 0;
	}
}
.viewcon-border-bottom {
	border-bottom: 1px solid #e4e7ec;
}
header.head {
	padding: 12px 20px;
}

.viewcon-tabs-height {
	height: calc(100vh - 255px);
	max-height: 800px;
}
.viewcon-modal-scroll {
	// height: calc(100vh - 360px);
	// max-height: 695px;
	// overflow: auto;
	padding: 10px 20px;
}

.viewcon-tabs-height .new-addBtn.btn-secondary {
	min-width: 87px;
}
.viewcon-tabs-height .new-cancelBtn.btn-secondary {
	min-width: 87px;
}

.viewcon-tabs-height .row {
	display: flex;
	flex-wrap: wrap;
	margin-right: 0;
	margin-left: 0;
}
.sel-config-card {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	border-radius: 5px;
	position: relative;
	display: flex;
	align-items: center;
	padding: 10px;
}
.sel-config-card .color-bar {
	background-color: #4ef085;
	height: 92%;
	width: 4px;
	border-radius: 6px;
	position: absolute;
	left: 5px;
}
.sel-config-card,
.viewcon-header {
	.one {
		width: 35%;
	}
	.one-alpha {
		width: 33%;
	}
	.two {
		width: 20%;
	}
	.three,
	.four {
		width: 14%;
	}
	.five,
	.six {
		width: 14%;
	}
	.seven {
		width: 9%;
	}
	.seven-alpha {
		width: 9%;
	}
	.custom-control-label::before {
		border: #20639b solid 2px;
	}
	.custom-control-input:checked ~ .custom-control-label::before {
		color: #fff;
		background: #20639b !important;
		border-color: #ffffff !important;
		border-width: 4px;
	}
	.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
		background-image: none !important;
		border: 2px solid #20639b;
		border-radius: 50%;
	}
	.tag {
		background: #ccfacb;
		border-radius: 4px;
		padding: 3px 20px;
		font-family: "Lato", sans-serif;
		font-weight: 400;
		font-size: 12px;
		color: #038e00;
		position: absolute;
		top: -16px;
		left: 26px;
	}
	.active-bar {
		width: 3px;
		height: 85%;
		background-color: #e70016;
		position: absolute;
		left: 3px;
		border-radius: 4px;
	}
	.active-bar.red {
		background-color: #e70016;
	}
	.active-bar.green {
		background-color: #038e00;
	}
}
.viewcon-header {
	background-color: #f4f4f6;
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
	display: flex;
	padding: 10px 10px 10px 10px;
}
.pl-40 {
	padding-left: 40px;
}
.view-con-hor-scroll {
	width: 100%;
	overflow-x: auto;
	padding: 4px;
}
.viewcon-vertical-scroll {
	height: calc(100vh - 486px);
	max-height: 570px;
	overflow: auto;
	padding: 4px;
}
.viewcon-vertical-scroll-2 {
	height: calc(100vh - 582px);
	max-height: 472px;
	overflow: auto;
	padding: 4px;
}

.filter-red-dot {
	background-color: #eb0002;
	height: 5px;
	width: 5px;
	position: absolute;
	border-radius: 10px;
	top: 13px;
	right: 70px;
}

.double-line-truncate {
	word-break: break-word;
	word-wrap: break-word;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	@supports (-webkit-line-clamp: 2) {
		display: -webkit-box !important;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		-webkit-line-clamp: 2;
	}
}
</style>
